module.exports = __webpack_public_path__ + "static/media/datasheet_listData_row6_startplaying.239c7911.png";